import { render, staticRenderFns } from "./ProductPerformanceHeader.vue?vue&type=template&id=ce05f6a6&scoped=true"
import script from "./ProductPerformanceHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPerformanceHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductPerformanceHeader.vue?vue&type=style&index=0&id=ce05f6a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce05f6a6",
  null
  
)

export default component.exports